<script context="module">
	import { writable } from "svelte/store";

	// Internal state store
	const state = writable({
		visible: false,
	});

	// Public API (programmatic usage)
	export const Loader = {
		display(/* arg = {} */) {
			state.set({
				visible: true,
			});
		},
		hide() {
			state.update((s) => ({ ...s, visible: false }));
		},

		// Optional helper for async/await one-liners
		async withTask(promise) {
			try {
				Loader.display();
				return await promise;
			} finally {
				Loader.hide();
			}
		},
		state,
	};
</script>

<script>
	import { onDestroy } from "svelte";

	let stateValue = { visible: false };

	const unsub = Loader.state.subscribe((v) => (stateValue = v));
	onDestroy(unsub);
</script>

{#if stateValue.visible}
	<div id="loaderOverlay">
		<div class="loaderSpinner spin"></div>
	</div>
{/if}
